import {ShapeCommand} from '../commands.template';

export class TextDeleteCommand extends ShapeCommand {
  // protected firstAction: boolean;
  protected services: any;

  constructor(data) {
    super(data);
    // this.firstAction = false;
  }

  public execute() {
    super.execute();
    // if (this.firstAction) {
    //   this.firstAction = false;
    //   return this.executeJson(this.object);
    // }
    const graph = this.services.editorRegistrySvc.getGraph();
    const textVertex = this.services.graphHelperSvc
      .allTexts()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));

    graph.removeCells([textVertex], false);

    return this.executeJson(this.object);
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteText: {mxKey: Number(data.mxKey)}
    });
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();
    const textVertex = this.services.shapeSpawnerSvc.createText(this.object);

    graph.addCell(textVertex, this.services.graphHelperSvc.textParent());

    return this.reverseJson(this.object);
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      createText: {
        mxKey: Number(data.mxKey),
        number: Number(data.number),
        text: data.text,
        customStyle: data.customStyle,
        style: data.style,
        position: {
          x: data.position.x,
          y: data.position.y,
          w: data.position.w,
          h: data.position.h
        },
        locked: Boolean(data.locked),
        link: data.link
      }
    });
  }
}
